import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Eye } from 'lucide-react';
import { navigateWithState } from '../utils/navigationState';

const ViewResourceProfileButton = ({ 
  resourceId, 
  variant = "outline", 
  size = "sm", 
  className = "",
  navigationState = null  // Optional: state to save before navigation
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    console.log('🔍 ViewResourceProfileButton clicked with resourceId:', resourceId);
    
    if (navigationState) {
      // Save navigation state before navigating
      navigateWithState(navigate, `/resources/${resourceId}`, navigationState);
    } else {
      // Direct navigation without state
      navigate(`/resources/${resourceId}`);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      className={className}
    >
      <Eye className="w-4 h-4 mr-2" />
      View Profile
    </Button>
  );
};

export default ViewResourceProfileButton;
